// src/utils/stringUtils.js

/**
 * Normalizes a string for search comparison.
 * Removes accents, diacritics, and converts to lowercase.
 * Example: "José García" -> "jose garcia"
 * @param {string|null|undefined} str 
 * @returns {string} Normalized string
 */
export function normalizeSearch(str) {
    if (!str) return "";
    return String(str)
        .normalize("NFD") // Decompose accents (e.g., 'é' -> 'e' + '´')
        .replace(/[\u0300-\u036f]/g, "") // Remove the accent marks
        .toLowerCase();
}
